
import React from 'react';

const CalendarLegend: React.FC = () => {
  return (
    <div className="mt-4 pt-3 border-t border-gray-100 space-y-2">
      <div className="flex items-center gap-6 text-xs text-gray-600">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 bg-blue-50 border border-blue-200 rounded"></div>
          <span>Com horários</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 bg-gray-50 border border-gray-200 rounded"></div>
          <span>Sem horários</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-1 h-1 bg-blue-500 rounded-full"></div>
          <span>Configurado</span>
        </div>
      </div>
    </div>
  );
};

export default CalendarLegend;
